import { render, staticRenderFns } from "./GruposUsers.vue?vue&type=template&id=6f1e46d8&"
import script from "./GruposUsers.vue?vue&type=script&lang=js&"
export * from "./GruposUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports